import {
    Eye,
    Pencil,
    Trash2,
    Send,
    MoreVertical,
} from "lucide-react";

import StatusBadge from "./StatusBadge";

export default function BeginningBalanceTable({
    data = [],
    loading = false,
    onDetail,
    onEdit,
    onDelete,
    onPosting,
}) {

    if (loading) {
        return (
            <div className="bg-white border rounded-xl p-10 text-center">
                Loading Beginning Balance...
            </div>
        );
    }

    return (
        <div className="bg-white border border-slate-200 rounded-xl overflow-hidden">

            {/* Header */}

            <div className="px-6 py-4 border-b flex justify-between items-center">

                <div>

                    <h2 className="font-semibold text-slate-800">
                        Beginning Balance List
                    </h2>

                    <p className="text-sm text-gray-500">
                        Warehouse opening stock
                    </p>

                </div>

                <div className="text-sm text-gray-500">

                    Total Data

                    <span className="font-semibold text-slate-700 ml-2">

                        {data.length}

                    </span>

                </div>

            </div>

            {/* Table */}

            <div className="overflow-auto max-h-[650px]">

                <table className="min-w-full text-sm">

                    <thead className="sticky top-0 bg-slate-100 z-10">

                        <tr className="text-slate-700">

                            <th className="px-4 py-3 w-12">

                                <input type="checkbox" />

                            </th>

                            <th className="px-4 py-3 text-left">

                                Batch Number

                            </th>

                            <th className="px-4 py-3">

                                Warehouse

                            </th>

                            <th className="px-4 py-3">

                                Rack

                            </th>

                            <th className="px-4 py-3">

                                Total Box

                            </th>

                            <th className="px-4 py-3">

                                Total Qty

                            </th>

                            <th className="px-4 py-3">

                                Status

                            </th>

                            <th className="px-4 py-3">

                                Created By

                            </th>

                            <th className="px-4 py-3">

                                Created At

                            </th>

                            <th className="px-4 py-3 text-center">

                                Action

                            </th>

                        </tr>

                    </thead>

                    <tbody>

                        {data.length === 0 && (

                            <tr>

                                <td
                                    colSpan="10"
                                    className="text-center py-20 text-gray-400"
                                >

                                    No Beginning Balance Found

                                </td>

                            </tr>

                        )}

                        {data.map((row) => (

                            <tr
                                key={row.id}
                                className="border-b hover:bg-blue-50 transition"
                            >

                                <td className="px-4 py-4">

                                    <input type="checkbox" />

                                </td>

                                <td className="px-4 py-4 font-semibold">

                                    {row.batch_number}

                                </td>

                                <td className="text-center">

                                    {row.warehouse}

                                </td>

                                <td className="text-center">

                                    {row.rack_code}

                                </td>

                                <td className="text-center">

                                    {row.total_box}

                                </td>

                                <td className="text-center">

                                    {Number(row.total_qty).toLocaleString()}

                                </td>

                                <td className="text-center">

                                    <StatusBadge
                                        status={row.status}
                                    />

                                </td>

                                <td className="text-center">

                                    {row.created_by}

                                </td>

                                <td className="text-center">

                                    {row.created_at}

                                </td>

                                <td>

                                    <div className="flex justify-center gap-2">

                                        <button
                                            onClick={() => onDetail(row)}
                                            className="p-2 rounded hover:bg-sky-100"
                                        >

                                            <Eye
                                                size={18}
                                                className="text-sky-600"
                                            />

                                        </button>

                                        {row.status !== "Posted" && (

                                            <>

                                                <button
                                                    onClick={() => onEdit(row)}
                                                    className="p-2 rounded hover:bg-green-100"
                                                >

                                                    <Pencil
                                                        size={18}
                                                        className="text-green-600"
                                                    />

                                                </button>

                                                <button
                                                    onClick={() => onPosting(row)}
                                                    className="p-2 rounded hover:bg-blue-100"
                                                >

                                                    <Send
                                                        size={18}
                                                        className="text-blue-600"
                                                    />

                                                </button>

                                                <button
                                                    onClick={() => onDelete(row)}
                                                    className="p-2 rounded hover:bg-red-100"
                                                >

                                                    <Trash2
                                                        size={18}
                                                        className="text-red-600"
                                                    />

                                                </button>

                                            </>

                                        )}

                                        <button
                                            className="p-2 rounded hover:bg-gray-100"
                                        >

                                            <MoreVertical
                                                size={18}
                                            />

                                        </button>

                                    </div>

                                </td>

                            </tr>

                        ))}

                    </tbody>

                </table>

            </div>

        </div>
    );
}